import React from 'react';
import { Card, Typography, Box } from '@mui/material';
import { StoryTemplate, STORY_TEMPLATE_LABELS } from '../../types/models/Newspaper';

const TEMPLATE_CONFIG: {
  key: StoryTemplate;
  description: string;
  emoji: string;
  color: string;
}[] = [
  { key: 'news_story', description: 'Report on something that happened', emoji: '📰', color: '#1565c0' },
  { key: 'feature_story', description: 'Tell an in-depth story about a topic', emoji: '✨', color: '#6a1b9a' },
  { key: 'book_review', description: 'Share your opinion about a book you read', emoji: '📚', color: '#7c3aed' },
  { key: 'restaurant_review', description: 'Tell us about a place you ate', emoji: '🍕', color: '#ea580c' },
  { key: 'movie_review', description: 'Review a movie you watched', emoji: '🎬', color: '#c62828' },
  { key: 'opinion', description: 'Write about something you believe', emoji: '💬', color: '#2e7d32' },
  { key: 'profile_interview', description: 'Interview someone and write about them', emoji: '🎤', color: '#00838f' },
  { key: 'recipe', description: 'Share how to make your favorite food', emoji: '🧑‍🍳', color: '#ef6c00' },
  { key: 'photo_essay', description: 'Tell a story with pictures and words', emoji: '📷', color: '#37474f' },
  { key: 'video_game_review', description: 'Review a video game you played', emoji: '🎮', color: '#283593' },
];

interface Props {
  onSelect: (templateType: StoryTemplate) => void;
  disabled?: boolean;
}

export default function TemplatePicker({ onSelect, disabled }: Props) {
  return (
    <Box sx={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
      gap: 1.5,
    }}>
      {TEMPLATE_CONFIG.map((template) => (
        <Card
          key={template.key}
          onClick={() => !disabled && onSelect(template.key)}
          elevation={2}
          sx={{
            p: 2,
            cursor: disabled ? 'default' : 'pointer',
            opacity: disabled ? 0.5 : 1,
            border: '2px solid transparent',
            transition: 'all 0.15s ease',
            '&:hover': disabled ? {} : {
              border: `2px solid ${template.color}`,
              transform: 'translateY(-2px)',
              boxShadow: `0 4px 12px ${template.color}33`,
            },
          }}
        >
          <Typography fontSize="2rem" lineHeight={1} sx={{ mb: 1 }}>
            {template.emoji}
          </Typography>
          <Typography variant="body2" fontWeight={700} color={template.color}>
            {STORY_TEMPLATE_LABELS[template.key]}
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block', lineHeight: 1.3 }}>
            {template.description}
          </Typography>
        </Card>
      ))}
    </Box>
  );
}
